module.exports = __webpack_public_path__ + "static/media/roundedrect-primary-wide.a997c3c9.png";